//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import ItemsSearchField from '../Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../QSelectUtils.js'
import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import CardPropertyObjectItem from './CardPropertyObjectItem.vue'

function equalArrays (v1, v2) {
  if (v1 === v2) {
    return true
  } else if (v1 == null && v2 == null) {
    return true
  } else if (v1 == null || v2 == null) {
    return false
  }
  return Array.isArray(v1) && Array.isArray(v2) && v1.length === v2.length && v1.every((val, index) => val === v2[index] || val.key === v2[index].key)
}

export default {
  name: 'CardPropertyObject',
  components: {
    ItemsSearchField,
    CardPropertyObjectItem,
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const data = {
      changed: false,
      objectFieldConfig: null,
      componentProps: {
        url: null,
        getURL: null,
        dialogLabel: 'ВЫБОР ЗНАЧЕНИЙ',
        dialogColumns: null
      }
    }
    const config = this.tabProp || this.config || {}
    if (config.componentProps) {
      data.componentProps = Object.assign(data.componentProps, config.componentProps)
    }
    data.system = config.type === 'sysobject' || config.type === 'sysobjects'
    if (data.system) {
      data.multiple = config.type === 'sysobjects' || config.ismultiselect
    } else {
      data.multiple = config.type === 'objects'
    }
    if (data.componentProps.url || data.componentProps.getURL) {
      data.objectFieldConfig = createFieldConfig({
        allRecordsFn: this.getAvailableObjects,
        storeType: 'server'
      })
    } else {
      const vm = this
      data.objectFieldConfig = createFieldConfig(new Store({
        fullReadable: !!data.system,
        searchable: false,
        cached: true,
        proxy: {
          urlBase: data.system ? '/service/sysobj/find' : '/service/obj/search',
          get urlParams () {
            return vm.searchParams
          },
          searchParams: config.searchParams || null,
          searchParamKey: 'name'
        }
      }))
    }
    return data
  },
  computed: {
    readonly: function () {
      return !this.tabProp.editable
    },
    classes: function () {
      return this.changed ? 'object-card-property-changed' : undefined
    },
    dialogColumns: function () {
      return this.componentProps && this.componentProps.dialogColumns || null
    },
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    },
    objectsCount: function () {
      const value = this.object[this.tabProp.key]
      if (value) {
        if (Array.isArray(value)) {
          return value.length
        } else {
          return 1
        }
      }
      return 0
    },
    searchParams: function () {
      if (this.tabProp) {
        const params = {}
        // name: 0022
        if (this.system) {
          params.type = this.tabProp.choosetype
        } else {
          if (this.tabProp.objectchooseroot) {
            const root = this.tabProp.objectchooseroot[0]
            params.root = 'root.' + root.key
          }
          if (this.tabProp.objectchoosetypes && this.tabProp.objectchoosetypes.length) {
            params.type = this.tabProp.objectchoosetypes.map(o => o.id).join(',')
          }
          params.subtypes = this.tabProp.objectchoosesubtypes // this.tabProp.subtype
        }

        const columns = this.dialogColumns
        if (columns && columns.length) {
          const additionalProperties = columns.map(column => column.field || column.name).filter(propertyName => propertyName && propertyName !== 'name')
          if (additionalProperties.length) {
            params.add = additionalProperties.join(',')
          }
        }

        return params
      }
      return null
    }
  },
  watch: {
    objectInitial: {
      handler: function (object) {
        if (object) {
          this.updateChangeFlag()
        } else {
          this.changed = false
        }
      },
      immediate: true
    }
  },
  methods: {
    onChange: function (value) {
      this.updateChangeFlag()
    },
    onCopy: function (e) {
      e.stopPropagation()
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.object[this.tabProp.key].map(entry => entry.name).join(', ')], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    },
    updateChangeFlag: function () {
      if (this.object._card && this.object._card.indicateChanges) {
        const value = this.getValue()
        const valueInitial = this.getValue(this.objectInitial)
        this.changed = !equalArrays(value, valueInitial)
      }
    },
    getValue: function (object = this.object) {
      return object[this.tabProp.key]
    },
    getAvailableObjects: function () {
      return axiosGet({
        url: this.componentProps.url || this.componentProps.getURL(this.object),
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: 'Ошибка получения списка допустимых значений для поля ' + this.tabProp._nameUpperCase,
        msgTarget: this
      })
    }
  }
}
